<template>
  <div class="page-dashboard" id="home">
    <calendar v-show="calendarDisp || pcDisp" :pcDisp="pcDisp" />
    <div :class="{'twin-row' : pcDisp}">
      <warningmsg v-show="warningmsgDisp || pcDisp" :pcDisp="pcDisp" :triggerWarningmsgInfiniteBool="triggerWarningmsgInfiniteBool" />
      <knowledge v-show="knowledgeDisp || pcDisp" :pcDisp="pcDisp" :triggerKnowledgeInfiniteBool="triggerKnowledgeInfiniteBool" />
    </div>
    <contact v-show="contactDisp || pcDisp" :pcDisp="pcDisp" :triggerContactInfiniteBool="triggerContactInfiniteBool" />
    <poll v-show="pollDisp || pcDisp" :pcDisp="pcDisp" :triggerPollInfiniteBool="triggerPollInfiniteBool" />

  	<div class="icon-bar dash-bg-color-skin" v-show="!pcDisp">
  	  <a :class= "{ 'nav-active' : calendarDisp }"  @click.stop="toggleDashboard('calendarDisp')">
        <div class="tri dash-border-bottom-color-skin-dark-30"></div>
        <i class="fa fa-calendar"></i>
        <div class="icon-text">Activity</div>
      </a>
      <a :class= "{ 'nav-active' : warningmsgDisp }"  @click.stop="toggleDashboard('warningmsgDisp')">
        <div class="tri dash-border-bottom-color-skin-dark-30"></div>
        <i class="fa fa-warning "></i>
        <div class="icon-text">warning</div>
      </a>
  	  <a :class= "{ 'nav-active' : contactDisp }"  @click.stop="toggleDashboard('contactDisp')">
        <div class="tri dash-border-bottom-color-skin-dark-30"></div>
        <i class="fa fa-address-card"></i>
        <div class="icon-text">Contact</div>
      </a>
  	  <a :class= "{ 'nav-active' : knowledgeDisp }"  @click.stop="toggleDashboard('knowledgeDisp')">
        <div class="tri dash-border-bottom-color-skin-dark-30"></div>
        <i class="fa fa-newspaper-o"></i>
        <div class="icon-text">Knowledge</div>
      </a>
  	  <a :class= "{ 'nav-active' : pollDisp }"  @click.stop="toggleDashboard('pollDisp')">
        <div class="tri dash-border-bottom-color-skin-dark-30"></div>
        <i class="fa fa-align-left"></i>
        <div class="icon-text">Poll</div>
      </a>
  	</div>
  </div>
</template>

<script>
import warningmsg from 'components/warningmsg/component'
import calendar from 'components/calendar/component'
import contact from 'components/contact/component'
import knowledge from 'components/knowledge/component'
import poll from 'components/poll/component'

export default {
  name: 'home',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      calendarDisp: true,
      warningmsgDisp: false,
      contactDisp: false,
      knowledgeDisp: false,
      pollDisp: false,
      triggerWarningmsgInfiniteBool: this.$parent.$parent.$parent.pcDisp,
      triggerContactInfiniteBool: this.$parent.$parent.$parent.pcDisp,
      triggerKnowledgeInfiniteBool: this.$parent.$parent.$parent.pcDisp,
      triggerPollInfiniteBool: this.$parent.$parent.$parent.pcDisp
    }
  },
  components: {
    warningmsg,
    calendar,
    contact,
    knowledge,
    poll
  },
  computed: {
    pcDisp () {
      return this.app.pcDisp
    }
  },
  methods: {
    toggleDashboard (page) {
      this.calendarDisp = false
      this.warningmsgDisp = false
      this.contactDisp = false
      this.knowledgeDisp = false
      this.pollDisp = false
      switch (page) {
        case 'calendarDisp':
          this.calendarDisp = true
          break
        case 'warningmsgDisp':
          this.warningmsgDisp = true
          this.triggerWarningmsgInfiniteBool = true
          break
        case 'contactDisp':
          this.contactDisp = true
          this.triggerContactInfiniteBool = true
          break
        case 'knowledgeDisp':
          this.knowledgeDisp = true
          this.triggerKnowledgeInfiniteBool = true
          break
        case 'pollDisp':
          this.pollDisp = true
          this.triggerPollInfiniteBool = true
          break
        default:
          this.calendarDisp = true
          break
      }
    }
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?0da044ea